/*
 * Module for the Workflow Activity report criteria page
 */
rs.module("content/reports/criteria/workflowactivity",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var assignedUserFullNameHidden = criteria.js(jsSelectors.assignedUserFullNameHidden);
            var assignedUserNameSelect = criteria.js(jsSelectors.assignedUserNameSelect);
            var includeUnassignedWorkflowsCheckBox = criteria.js(jsSelectors.includeUnassignedWorkflowsCheckBox);

            // register changed events
            assignedUserNameSelect.change(assignedUserChanged);

            // On assigned user changed
            function assignedUserChanged() {

                var allAssignedUsers = assignedUserNameSelect.val() == "";

                if (allAssignedUsers) {
                    includeUnassignedWorkflowsCheckBox.prop("disabled", false);
                }
                else {
                    includeUnassignedWorkflowsCheckBox.prop("disabled", true);
                    includeUnassignedWorkflowsCheckBox.setChecked(false);
                }

                // Set Hidden Field (Assigned User Full Name) based on selected value
                assignedUserFullNameHidden.val(assignedUserNameSelect.find(":selected").text());
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);